import axios from 'axios';
import Api from "./Api";

class FileAssetAPI extends Api{

    fileInfo(fileId){

        let path = "/file/" + fileId + "/info";

        let endpoint =  this.combineUrl(this.apiHost,path);

        return this._get(endpoint).then(response =>  response)
    }


    provisionalUpload(file,data,onProgress){

        let path = "/file/provision";

        let endpoint =  this.combineUrl(this.apiHost,path);

        return this._upload(endpoint,file,data,onProgress)
    }


}

let _api = new FileAssetAPI();

export default _api;